export const invertedMessages = {
  Close: 'CloseLabel',
  'No emails have been configured for the certification':
    'Cert.NoEmailsConfigured.ATTESTATIONS',
  'Exception while fetching email history for certification':
    'Cert.Exceptionwhilefetchingemailhistoryforcertification.label',
  'Exception while fetching certification email history':
    'Cert.Exceptionwhilefetchingcertificationemailhistory.label',
};
